<template>
  <div class="tri-state-checkbox"
       :class="{
          'tri-state-checkbox_error': danger,
          'tri-state-checkbox_disabled': disabled
       }"
  >
    <div class="tri-state-checkbox__state tri-state-checkbox__state_false"
         :class="{
            'tri-state-checkbox__state_active': valueX === falseValue,
            'disabled': disabled
          }"
         @click="setValue(falseValue)">
      {{falseLabel}}
    </div>
    <div class="tri-state-checkbox__state tri-state-checkbox__state_true"
         :class="{'tri-state-checkbox__state_active': valueX === trueValue, 'disabled': disabled}"
         @click="setValue(trueValue)">
      {{trueLabel}}
    </div>

    <transition name="fade">
      <div v-if="danger" class="tri-state-checkbox__error-text">
        {{dangerText}}
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "Checkbox",
    props: {
      value: {},
      trueLabel: {
        type: String,
        default: 'Да'
      },
      falseLabel: {
        type: String,
        default: 'Нет'
      },
      trueValue: {
        default: true
      },
      falseValue: {
        default: false
      },
      danger: {
        default: false,
        type: Boolean
      },
      dangerText: {
        default: '',
        type: String
      },
      disabled: {
        default: false,
        type: Boolean
      }
    },
    computed:{
      valueX:{
        get(){
          return this.value;
        },
        set(value){
          this.$emit('input', value);
        }
      }
    },
    methods: {
      setValue(v){
        if(this.disabled) return false;
        this.valueX = v;
      }
    }
  }
</script>

<style lang="scss" scoped>
.tri-state-checkbox{
  display: inline-flex;
  align-items: center;
  border-radius: 2px;
  height: 30px;
  position: relative;


  &__state{
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex: 1;
    text-align: center;
    font-size: 1rem;
    height: 100%;
    min-width: 60px;
    line-height: 1.4;
    border: 1px solid rgba(0, 0, 0, 0.2);


    &+&{
      border-left-width: 0!important;
    }

    &_false{
      border-radius: 2px 0 0 2px;
    }

    &_true{
      border-radius: 0 2px 2px 0;
    }

    &_active#{&}_false,
    &_false:not(.disabled):hover{
      background: rgba(var(--vs-danger), 1);
      border-color: rgba(var(--vs-danger), 1)!important;
      color: #fff;
    }

    &_active#{&}_true,
    &_true:not(.disabled):hover{
      background: rgba(var(--vs-success), 1);
      border-color: rgba(var(--vs-success), 1)!important;
      color: #fff;
    }
  }

  &_disabled{
    opacity: .7;
    .tri-state-checkbox__state{
      cursor: default;

      &:hover{
        pointer-events: none;
      }
    }
  }


  &_error{
    .tri-state-checkbox__state{
      border-color: rgba(var(--vs-danger), 1);
    }
  }

  &__error-text{
    display: inline-block;
    color: rgba(var(--vs-danger),1)!important;
    overflow: hidden;
    transition: all .25s ease;
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
    margin-top: 3px;
    font-weight: 500;
    text-transform: uppercase;
    padding: 4px;
    line-height: 1.2;
    font-size: .7rem;
    border-radius: 2px;
    z-index: 100;
    position: absolute;
    top: 100%;
    left: 0;
  }
}
</style>